module.exports = __webpack_public_path__ + "static/media/Bariol-Thin.ac04cb34.woff";